import { all, fork } from "redux-saga/effects";

import DropDownListSaga from "./dropDownList/saga";
import newParticipantSaga from "./participants/saga";
import newStaff from "./staff/saga";
import StaffByEmail from "./staffByEmail/saga";
import ServiceSaga from "./services/saga";
import AdminSaga from "./superAdmin/saga";
import VehicleSaga from "./vehicle/saga";
import StaffViewSaga from "./employeePortal/saga";
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import calendarSaga from "./calendar/saga";
import chatSaga from "./chat/saga";
import invoiceSaga from "./invoices/saga";
import dashboardSaga from "./dashboard/saga";
import registerSaga from "./register/saga";
import trainingSaga from "./training/saga";
import RiskAssessmentSaga from "./riskAssessment/saga";
import PrivacyPolicySaga from "./privacyPolicy/saga";
import ShiftSaga from "./shift/saga";
import mailsSaga from "./mails/saga";
import fileMangerSaga from "./fileManager/saga";
import ServiceRecordSaga from "./serviceRecord/saga";
import OpenShiftSaga from "./openShift/saga";
import NoticeBoardSaga from "./noticeBoard/saga";
import ChatGPTSaga from "./chatGpt/saga";
import AdminsSaga from "./admin/saga";
import MedicationSaga from "./medication/saga";
import PrescriberSaga from "./prescriber/saga";
import TemplateSaga from "./template/saga";
import TeamSaga from "./team/saga";
import HazardReportSaga from "./hazardReport/saga";
import RoleAccessSaga from "./roleAccess/saga";
import ProgressNoteSaga from "./ProgressNote/saga";
import LocationSaga from "./location/saga";
import IntegrationSaga from "./integration/saga";
import ComplaintRegisterSaga from "./Complaints/saga";
import ratingDashboardSaga from "./ratingDashboard/saga";
import FundingReportSaga from "./fundingReport/saga";

export default function* rootSaga() {
  yield all([
    fork(FundingReportSaga),
    fork(ratingDashboardSaga),
    fork(ComplaintRegisterSaga),
    fork(IntegrationSaga),
    fork(LocationSaga),
    fork(ProgressNoteSaga),
    fork(RoleAccessSaga),
    fork(HazardReportSaga),
    fork(PrescriberSaga),
    fork(MedicationSaga),
    fork(TemplateSaga),
    fork(AdminsSaga),
    fork(ChatGPTSaga),
    fork(NoticeBoardSaga),
    fork(OpenShiftSaga),
    fork(ServiceRecordSaga),
    fork(fileMangerSaga),
    fork(mailsSaga),
    fork(ShiftSaga),
    fork(PrivacyPolicySaga),
    fork(RiskAssessmentSaga),
    fork(DropDownListSaga),
    fork(newParticipantSaga),
    fork(newStaff),
    fork(StaffByEmail),
    fork(ServiceSaga),
    fork(AdminSaga),
    fork(StaffViewSaga),
    fork(VehicleSaga),
    fork(registerSaga),
    fork(trainingSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(calendarSaga),
    fork(chatSaga),
    fork(invoiceSaga),
    fork(dashboardSaga),
    fork(TeamSaga),
  ]);
}
